import { MiraSection } from "@/data/models/Mira";
import { getReactiveActiveUser } from "@/data/repository/UserRepository";
import { isViewAsSelected } from "@/store/modules/TargetUserModule";
import { getEffectiveUser } from "@/utils/ViewAs";

/**
 * The figures the user chose for a Mira landing card (#2610102), in order; empty for the default.
 * Under "Sicht auf" the chosen user's, since the app shows exactly what that user sees (reactive).
 */
export function miraLandingChoice(section: MiraSection): string[] {
  return getEffectiveUser()?.miraLandingFigures?.[section] ?? [];
}

/**
 * Whether the user may change their landing cards' figures: never under "Sicht auf", which is strictly
 * read-only (ticket 2610051), and never without a user record to save on (the `Master` login).
 */
export function mayEditMiraLandingChoice(): boolean {
  const user = getReactiveActiveUser();
  return !isViewAsSelected() && !!user?.id && user.id !== "Master";
}
